import { Controller } from "@hotwired/stimulus"

const TERMINAL = ["completed", "failed"]

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 60000 },
    status: String,
  }

  connect() {
    if (!TERMINAL.includes(this.statusValue)) {
      this._startPolling()
      this._startVisibilityWatch()
    }
  }

  disconnect() {
    this._stopPolling()
    this._stopVisibilityWatch()
  }

  statusValueChanged() {
    if (TERMINAL.includes(this.statusValue)) {
      this._stopPolling()
      this._stopVisibilityWatch()
    }
  }

  async refresh() {
    if (!this.urlValue) return
    try {
      const resp = await fetch(this.urlValue, {
        headers: { "Accept": "text/vnd.turbo-stream.html" }
      })
      if (!resp.ok) return
      Turbo.renderStreamMessage(await resp.text())
    } catch (e) {
      console.warn("[auto-refresh]", e)
    }
  }

  _startPolling() {
    this._stopPolling()
    this._timer = setInterval(() => this.refresh(), this.intervalValue)
  }

  _stopPolling() {
    clearInterval(this._timer)
    this._timer = null
  }

  _startVisibilityWatch() {
    this._visHandler = () => {
      if (document.visibilityState === "visible" && !TERMINAL.includes(this.statusValue))
        this.refresh()
    }
    document.addEventListener("visibilitychange", this._visHandler)
  }

  _stopVisibilityWatch() {
    document.removeEventListener("visibilitychange", this._visHandler)
    this._visHandler = null
  }
}
